import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        token: '123',
        lastVisitPath: '',
        oldUrl: 'http://global.aitrans.org.cn/old',
        menu: []
    },
    mutations: {
        setToken: (state, data) => state.token = data,
        setPath: (state, data) => state.lastVisitPath = data,
        setMenu: (state, data) => state.menu = data,
    },
    actions: {
        acSetToken(context, token) {
            context.commit('setToken', token)
        },
        acSetMenu(context) {
            Vue.prototype.$util.post({
                params: {
                    "data": {
                        userType: JSON.parse(localStorage.getItem('userinfo')) ? JSON.parse(localStorage.getItem('userinfo')).userType : 0
                    }
                },
                url: '/dict/getMenu',
                success: (res) => {
                    if (res.resultCode == 200) {
                        context.commit("setMenu", res.data)
                    } else {
                        this.$Message.error('查询失败!');
                    }
                },
                error: (err) => {
                    console.log('失败', err)
                }
            });
        }
    },
})

export default store